import { render } from "./OfferRecord.vue?vue&type=template&id=012f8eaf&scoped=true"
import script from "./OfferRecord.vue?vue&type=script&lang=js"
export * from "./OfferRecord.vue?vue&type=script&lang=js"

import "./OfferRecord.vue?vue&type=style&index=0&id=012f8eaf&scoped=true&lang=css"
import "./OfferRecord.vue?vue&type=style&index=1&id=012f8eaf&lang=css"
import "./OfferRecord.vue?vue&type=style&index=2&id=012f8eaf&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=3&id=012f8eaf&scoped=true&lang=css"

import exportComponent from "/var/www/dev.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012f8eaf"]])

export default __exports__